<input
	[formControl]="formControl"
	class="mat-input-element"
	[readonly]="readonly"
/>
